import {t} from "@lingui/core/macro";
import * as React from "react";

import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";

import {
    NavLink,
    NavSection,
} from "#components/side-nav-page-layout-package/nav-links/index.ts";

import type {NavLinkDetail, NavSectionDetail} from "../homepage-data.ts";

import KhanmigoActivitiesLabel from "./khanmigo-activities-label.tsx";

const Section = ({
    section,
}: {
    section: NavSectionDetail;
}): React.ReactElement => {
    const getLabel = (link: NavLinkDetail): string | JSX.Element => {
        // Special promotional label for Khanmigo Activities link
        if (link.label === t`Activities`) {
            return <KhanmigoActivitiesLabel label={link.label} />;
        }

        return link.label;
    };
    const publishAnalyticsEvent = usePublishAnalyticsEvent();

    return (
        <NavSection label={section.label} tag="h2">
            {section.links.map((link, index) => (
                <NavLink
                    key={index}
                    label={getLabel(link)}
                    href={link.href}
                    testId={link.testId}
                    handleIsCurrentPage={link.linkMatcher}
                    onClick={() => {
                        publishAnalyticsEvent({
                            eventType: "LoggedInHomepageSideNavClassSelected",
                            eventSchemaVersion: 1,
                            className: link.label,
                        });
                    }}
                />
            ))}
        </NavSection>
    );
};

export default React.memo(Section);
